/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function MaterializeSheetRowHierarchyRequestFromJSON(json) {
    return MaterializeSheetRowHierarchyRequestFromJSONTyped(json, false);
}
export function MaterializeSheetRowHierarchyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
    };
}
export function MaterializeSheetRowHierarchyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
    };
}
